import { useEffect } from "react";

/**
 * Shared scroll-reveal hook. Observes `.reveal` children inside the ref
 * and adds `.is-visible` when they enter the viewport.
 */
export function useScrollReveal(ref: React.RefObject<HTMLElement | null>, threshold = 0.1) {
  useEffect(() => {
    if (!ref.current) return;
    const els = ref.current.querySelectorAll<HTMLElement>(".reveal");
    if (els.length === 0) return;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            (e.target as HTMLElement).classList.add("is-visible");
          }
        });
      },
      { threshold },
    );

    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, [ref, threshold]);
}
